import { Button, Col, Form, Input, Modal, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import useWindowDimensions from '../../Hooks/WindowDimensions';
import cl from './ModalAddToBasket.module.css';
import { addBasket } from '../../Redux/actions';
import { toSplitThousand } from '../../Hooks/SplitThousand';

const ModalAddToBasket = ({
    open,
    setOpen,
    id,
    title,
    price,
    article,
    unit,
    factor = [],
    activePrice,
    media,
}) => {
    const { width } = useWindowDimensions();
    const [count, setCount] = useState(1);
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const confirmHandler = () => {
        dispatch(
            addBasket({ id, title, price, number: count, article, unit, media })
        );
        form.resetFields();
        setOpen(false);
    };
    useEffect(() => {
        if (open) {
            form.setFieldValue('count', 1);
            setCount(1);
            factor.forEach((item, index) => {
                form.setFieldValue(
                    `factor${index}`,
                    Math.ceil(1 * item.conversionFactor)
                );
            });
        }
    }, [factor, open]);
    const changeCountHandler = (e, key) => {
        let value = +e.target.value;
        if (key === 'main') {
            if (value < 1) {
                value = 1;
                form.setFieldValue('count', 1);
            }
            setCount(value);
            factor.forEach((item, index) => {
                form.setFieldValue(
                    `factor${index}`,
                    Math.ceil(value * item.conversionFactor)
                );
            });
        } else {
            if (value < 1) {
                value = 1;
                form.setFieldsValue(`factor${key}`, 1);
            }
            const factorItem = factor[key].conversionFactor;
            let main = Math.ceil(value / factorItem);
            form.setFieldValue('count', main);
            setCount(main);
            main = value / factorItem;
            factor.forEach((item, index) => {
                if (key !== index) {
                    form.setFieldValue(
                        `factor${index}`,
                        Math.ceil(main * item.conversionFactor)
                    );
                }
            });
        }
    };
    return (
        <Modal
            centered
            open={open}
            onCancel={() => {
                form.resetFields();
                setOpen(false);
            }}
            onOk={confirmHandler}
            okText="Добавить"
            footer={false}
            width="757px"
        >
            <Row>
                <Col span={width <= 768 ? 24 : 12}>
                    <Row className={cl.titleContainerAdd}>
                        <p className={cl.title}>{title}</p>
                    </Row>

                    {width <= 768 && (
                        <Col span={24} style={{ marginBottom: 20 }}>
                            <Row
                                className={`${cl.imgContainer} ${cl.modalImgContainer}`}
                            >
                                <img
                                    alt=""
                                    src={media[0]?.path ?? '/productImg.svg'}
                                    style={{
                                        width: '100%',
                                    }}
                                />
                            </Row>
                        </Col>
                    )}
                    <Form
                        layout="vertical"
                        className="form-add-product"
                        form={form}
                    >
                        <Row style={{ gap: '6px', justifyContent: 'center' }}>
                            <Col span={6}>
                                <Form.Item label="штука" name="count">
                                    <Input
                                        type="number"
                                        min="1"
                                        onChange={(e) => {
                                            changeCountHandler(e, 'main');
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            {factor.map((item, index) => (
                                <Col span={6} key={item.factor}>
                                    <Form.Item
                                        label={item.unit}
                                        type="number"
                                        min={0.1}
                                        name={`factor${index}`}
                                    >
                                        <Input
                                            onChange={(e) => {
                                                changeCountHandler(e, index);
                                            }}
                                        />
                                    </Form.Item>
                                </Col>
                            ))}
                        </Row>
                    </Form>

                    <Row className={cl.rowForm}>
                        <span className={cl.finaly}>
                            Итого: {toSplitThousand(count * price[activePrice])}
                        </span>
                    </Row>
                    <Row justify="center">
                        <Button
                            size="large"
                            style={{ width: 200 }}
                            type="primary"
                            className={cl.addBtn}
                            onClick={confirmHandler}
                        >
                            Добавить в корзину
                        </Button>
                    </Row>
                </Col>

                {width > 768 && (
                    <Col span={12}>
                        <Row className={cl.imgContainer}>
                            <img
                                style={{
                                    width: '100%',
                                }}
                                alt=""
                                src={media?.at[0]?.path ?? '/productImg.svg'}
                            />
                        </Row>
                    </Col>
                )}
            </Row>
        </Modal>
    );
};

export default ModalAddToBasket;
